import React, { useEffect, useState } from 'react';
import { ISendGridEvent, useGetSendGridEventsQuery } from '../../generated/graphql';
import { Colors } from '../../utils/theme';
import { Box, CircularProgress } from '@mui/material';
import EventDetail from './EventDetail';

interface IProps {
  messageId: string;
}

const MessageDetails: React.FunctionComponent<IProps> = ({ messageId }: IProps) => {
  const [messageDetails, setMessageDetails] = useState<ISendGridEvent[] | null>(null);
  const { data, loading } = useGetSendGridEventsQuery({
    variables: {
      sg_message_id: messageId
    },
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (data && data.result) {
      setMessageDetails(data.result as ISendGridEvent[]);
    }
  }, [data]);

  return (
    <Box>
      {loading ? (
        <Box style={{ textAlign: 'center', color: Colors.main }}>
          <CircularProgress color="inherit" />
        </Box>
      ) : (
        <Box key={messageId}>
          {messageDetails?.map((e, i) => (
            <EventDetail key={i} event={e} />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default MessageDetails;
